var map = {
	"./affidabiliinterattivi.png": "9678",
	"./alberolima.png": "dce4",
	"./analisi.png": "1f74",
	"./autoproduzione.png": "ea120",
	"./bergamocitta.png": "9ed2",
	"./blufi_cer.png": "e504f",
	"./blufi_progetto.png": "7c8e",
	"./buselettrici.png": "3388",
	"./busesred.png": "5aa2",
	"./busmonza.png": "9888",
	"./cadizponte.png": "5439",
	"./cadizporto.png": "f1dc",
	"./calderara_energia.png": "4d2e",
	"./calderara_progetto.png": "a955",
	"./capolavoriluce.png": "e910",
	"./caricaebus.png": "f65c",
	"./caruaruvista.png": "ac3a",
	"./castellosforzesco.png": "9fec",
	"./catanzaropiazza.png": "9fc4",
	"./catanzarostatua.png": "9f60",
	"./cattedrale_monza.png": "62e4",
	"./centrostorico.png": "b8a7",
	"./chiaviinmano.png": "04dd",
	"./christmasroute.png": "0bb1",
	"./colinacarrello.png": "1756",
	"./colinaebus1.png": "dcc7",
	"./colinaebus2.png": "9cba",
	"./collepardovista.png": "8f00",
	"./combinazionevincente.png": "61c5",
	"./comfortvisivo.png": "d621",
	"./compositareis.png": "63f3",
	"./comunita.png": "8169",
	"./controlloremoto.png": "13a3",
	"./curitibaebus1.png": "5448",
	"./curitibaebus2.png": "2011",
	"./curitibaebus3.png": "4f8a",
	"./datipianificare.png": "262a",
	"./david_michelangelo.png": "ff61",
	"./decorazioniangra.png": "f587",
	"./doorvernazza.png": "9281",
	"./economiadigital.png": "dffb",
	"./efficientamento.png": "5061",
	"./efficienzaqualita.png": "ea73",
	"./elettroterminali.png": "22d9",
	"./emt_pantografi.png": "2502",
	"./emt_progetto.png": "bdfb",
	"./energetico.png": "192f",
	"./figurenatalelima.png": "2040",
	"./firenzemuseo900.png": "7458",
	"./firenzesostenibile.png": "7c43",
	"./gemonadelfriulivista.png": "c103",
	"./goticaburgos.png": "3736",
	"./granadapanorama.png": "6c7f",
	"./granadauniversity.png": "27fc",
	"./guardareavanti.png": "a8e0",
	"./hero/aeronautica_roma_hero_bg.png": "2d1b",
	"./hero/aeronautica_roma_hero_card.png": "0c46",
	"./hero/aires_background_hero.png": "58f8",
	"./hero/angrachristmast_background_hero.png": "26a0",
	"./hero/assisi_background_hero.png": "0f55",
	"./hero/barcellona_background_hero.png": "2bb8",
	"./hero/bergamo.png": "ae5c",
	"./hero/bergamo_hero_card.png": "9eb9",
	"./hero/blufi_hero_bg.png": "05ef",
	"./hero/blufi_hero_card.png": "d0e9",
	"./hero/blufi_hero_image.png": "92e4",
	"./hero/bogota_background_hero.png": "ce90",
	"./hero/bogotaarchitectural_background_hero.png": "2e98",
	"./hero/bogotaarchitecturallighting_background_hero.png": "6821",
	"./hero/bogotaefficientlight_background_hero.png": "4d7d",
	"./hero/bologna_adaptivelight_background_hero.png": "ae9d",
	"./hero/bologna_background_hero.png": "0f1f",
	"./hero/bologna_trafficlight_background_hero.png": "e0fb",
	"./hero/brasov_background_hero.png": "ea32",
	"./hero/brindisi_background_hero.png": "4a3a",
	"./hero/burgos_background_hero.png": "c830",
	"./hero/cadiz_background_hero.png": "c8b3",
	"./hero/cadiz_hero_card.png": "d2c1",
	"./hero/calderara_hero.png": "da36",
	"./hero/calderara_hero_bg.png": "6892",
	"./hero/calderara_hero_card.png": "cc48",
	"./hero/card_aires_background.png": "ac08",
	"./hero/card_angrachristmast_background.png": "117f",
	"./hero/card_assisi_background.png": "1b92",
	"./hero/card_barcellona_background.png": "1b18",
	"./hero/card_bogota_background.png": "e2a0",
	"./hero/card_bogotaarchitectural_background.png": "af45",
	"./hero/card_bogotaarchitecturallighting_background.png": "0e4c",
	"./hero/card_bogotaefficientlight_background.png": "3574",
	"./hero/card_bologna_adaptivelight_background.png": "3ce0",
	"./hero/card_bologna_background.png": "01d2",
	"./hero/card_bologna_trafficlight_background.png": "4233",
	"./hero/card_brasov_background.png": "bc1b",
	"./hero/card_brindisi_background.png": "af7b",
	"./hero/card_burgos_background.png": "febb",
	"./hero/card_chileebuscovid19_background.png": "9dd8",
	"./hero/card_chilesafety_background.png": "9116",
	"./hero/card_cityanalyticsmobility_background.png": "5364",
	"./hero/card_concepcion_background.png": "f216",
	"./hero/card_concepcionhospital_background.png": "50c42",
	"./hero/card_conchali_background.png": "06c0",
	"./hero/card_energychile_background.png": "db31",
	"./hero/card_ezeiza_background.png": "1181",
	"./hero/card_floridaplaza_background.png": "2630",
	"./hero/card_genova_background.png": "d349",
	"./hero/card_jean_background.png": "a686",
	"./hero/card_laflorida_background.png": "2d05",
	"./hero/card_lanus_background.png": "7701",
	"./hero/card_lecce_background.png": "7008",
	"./hero/card_lima_background.png": "6d7e",
	"./hero/card_limaheritage_background.png": "a590",
	"./hero/card_limatemporal_background.png": "27c2",
	"./hero/card_masloc_background.png": "ffdd",
	"./hero/card_mataro_background.png": "c800",
	"./hero/card_mateu_background.png": "ac1b",
	"./hero/card_meridalighting_background.png": "d80c",
	"./hero/card_monza_background.png": "9c60",
	"./hero/card_pescara_background.png": "14aa",
	"./hero/card_quincy_background.png": "4c05",
	"./hero/card_recea_background.png": "ea24",
	"./hero/card_regional_background.png": "25b9",
	"./hero/card_reislighting_background.png": "45b3",
	"./hero/card_rome_background.png": "9d24",
	"./hero/card_sanmauro_background.png": "8df4",
	"./hero/card_sanpaolo_background.png": "7f1b",
	"./hero/card_santiago_background.png": "a2c5",
	"./hero/card_santiagodechileebus_background.png": "e069",
	"./hero/card_sarria_background.png": "bc1bf",
	"./hero/card_sernobi_background.png": "65e1",
	"./hero/card_tango_background.png": "078e",
	"./hero/card_turin_background.png": "b90e",
	"./hero/card_vernazza_background.png": "52bd",
	"./hero/card_vernazzaheritage_background.png": "f43f",
	"./hero/card_vitoria_background.png": "cfe2",
	"./hero/card_zaragoza_background.png": "5541",
	"./hero/caruaru_background_hero.png": "e8cb",
	"./hero/caruaru_hero_card.png": "5595",
	"./hero/catanzaro.png": "ccb8",
	"./hero/catanzaro_hero_card.png": "5ea0",
	"./hero/cattedrale_monza_hero_bg.png": "b18c",
	"./hero/cattedrale_monza_hero_card.png": "c28d",
	"./hero/chileebuscovid19_background_hero.png": "3bd9",
	"./hero/chilesafety_background_hero.png": "5e34",
	"./hero/cityanalyticsmobility_background_hero.png": "b292",
	"./hero/colina_background_hero.png": "a3de",
	"./hero/colina_hero_card.png": "f5d1",
	"./hero/collepardo_background_hero.png": "49a1",
	"./hero/collepardo_hero_card.png": "b79e",
	"./hero/concepcion_background_hero.png": "01e0",
	"./hero/concepcionhospital_background_hero.png": "373f",
	"./hero/conchali_background_hero.png": "76e1",
	"./hero/curitiba_background_hero.png": "0810",
	"./hero/curitiba_hero_card.png": "1cf3",
	"./hero/david_michelangelo.png": "fe90",
	"./hero/david_michelangelo_hero_bg.png": "e1c8",
	"./hero/david_michelangelo_hero_card.png": "11aa",
	"./hero/emt_madrid_hero_bg.png": "fedd",
	"./hero/emt_madrid_hero_card.png": "245b",
	"./hero/energychile_background_hero.png": "5731",
	"./hero/ezeiza_background_hero.png": "98be",
	"./hero/firenze.png": "4a1b",
	"./hero/firenze_hero_card.png": "6e2a",
	"./hero/floridaplaza_background_hero.png": "8dd5",
	"./hero/gemonadelfriuli_background_hero.png": "cbc3",
	"./hero/gemonadelfriuli_hero_card.png": "0997",
	"./hero/genova_background_hero.png": "4374",
	"./hero/granada_background_hero.png": "14e3",
	"./hero/granada_hero_card.png": "d8c1",
	"./hero/jabaotao_hero_card.png": "23d3",
	"./hero/jaboatao_background_hero.png": "5e58",
	"./hero/jaboatao_xmas_background_hero.png": "ca92",
	"./hero/jean_background_hero.png": "69d1",
	"./hero/laflorida_background_hero.png": "1624",
	"./hero/lanus_background_hero.png": "728f",
	"./hero/lecce_background_hero.png": "970f",
	"./hero/legnano_venaria.png": "1cc2",
	"./hero/legnano_venaria_hero_card.png": "6da5",
	"./hero/lima_background_hero.png": "9858",
	"./hero/limaheritage_background_hero.png": "8bbf",
	"./hero/limatemporal_background_hero.png": "cd93",
	"./hero/map_assisi.png": "75de",
	"./hero/map_barcellona.png": "81d6",
	"./hero/map_blufi.png": "e2b6",
	"./hero/map_bogota.png": "b2c3",
	"./hero/map_bologna.png": "6512",
	"./hero/map_brasil.png": "08f3",
	"./hero/map_brasil_christmast.png": "3c03",
	"./hero/map_brasov.png": "77b7",
	"./hero/map_brindisi.png": "11bb",
	"./hero/map_burgos.png": "b6ff",
	"./hero/map_cadiz.png": "3060",
	"./hero/map_calderaradireno.png": "f27e",
	"./hero/map_caruaru.png": "f2e6",
	"./hero/map_catanzaro.png": "6bc6",
	"./hero/map_chile.png": "cba2",
	"./hero/map_chile_hospicio.png": "5153",
	"./hero/map_chile_urban.png": "466c",
	"./hero/map_chileebuscovid19.png": "9da9",
	"./hero/map_cityanalyticsmobility.png": "8699",
	"./hero/map_colina.png": "6e1e",
	"./hero/map_collepardo.png": "d425",
	"./hero/map_concepcion.png": "ddfb",
	"./hero/map_concepcionhospital.png": "492a",
	"./hero/map_conchali.png": "cd30",
	"./hero/map_curitiba.png": "d27f",
	"./hero/map_ezeiza.png": "20fd",
	"./hero/map_firenze.png": "00ec",
	"./hero/map_gemonadelfriuli.png": "0d5a",
	"./hero/map_genova.png": "d033",
	"./hero/map_granada.png": "655d",
	"./hero/map_jaboatao.png": "a42c",
	"./hero/map_jean.png": "ade6",
	"./hero/map_laflorida.png": "7fd4",
	"./hero/map_lanus.png": "335e",
	"./hero/map_lecce.png": "352b",
	"./hero/map_lima.png": "d166",
	"./hero/map_madrid.png": "e301",
	"./hero/map_masloc.png": "196f",
	"./hero/map_mataro.png": "cdbe",
	"./hero/map_mateu.png": "fabc",
	"./hero/map_merida.png": "28e7",
	"./hero/map_messina.png": "e30b",
	"./hero/map_milan.png": "ea99",
	"./hero/map_monza.png": "4568",
	"./hero/map_openindex.png": "a213",
	"./hero/map_penalonen.png": "7e2d",
	"./hero/map_pescara.png": "11bc",
	"./hero/map_quincy.png": "41f4",
	"./hero/map_recea.png": "10c0",
	"./hero/map_reggiocalabria.png": "781d",
	"./hero/map_regional.png": "a5e5",
	"./hero/map_rome.png": "7000",
	"./hero/map_sanmauro.png": "9591",
	"./hero/map_santarosa.png": "2c25",
	"./hero/map_sarria.png": "7707",
	"./hero/map_sernobi.png": "a0d6",
	"./hero/map_sevilla.png": "0888",
	"./hero/map_siracusa.png": "2a77",
	"./hero/map_trieste.png": "9549",
	"./hero/map_turin.png": "2736",
	"./hero/map_tussam.png": "0ca9",
	"./hero/map_vernazza.png": "1c91",
	"./hero/map_vitoria.png": "abb1",
	"./hero/map_zaragoza.png": "f2b3",
	"./hero/masloc_background_hero.png": "d16f",
	"./hero/mataro_background_hero.png": "f535",
	"./hero/mateu_background_hero.png": "ecfa",
	"./hero/meridalighting_background_hero.png": "f3ad",
	"./hero/messina_hero_bg.png": "1714",
	"./hero/messina_hero_card.png": "f0cd",
	"./hero/milan.png": "3622",
	"./hero/milan_hero_card.png": "7837",
	"./hero/milano_aler_background_hero.png": "66b1",
	"./hero/milano_hero_card.png": "9d17",
	"./hero/ministero_difesa_zoom.png": "802e",
	"./hero/mobile_map_assisi.svg": "7491",
	"./hero/mobile_map_barcellona.svg": "2eb2",
	"./hero/mobile_map_blufi.svg": "c365",
	"./hero/mobile_map_bogota.svg": "7f6f",
	"./hero/mobile_map_bologna.svg": "4b4f",
	"./hero/mobile_map_brasil_christmast.svg": "4539",
	"./hero/mobile_map_brasov.svg": "a9ad",
	"./hero/mobile_map_brindisi.svg": "8195",
	"./hero/mobile_map_burgos.svg": "6157",
	"./hero/mobile_map_cadiz.svg": "90ee",
	"./hero/mobile_map_calderaradireno.png": "1f73",
	"./hero/mobile_map_calderaradireno.svg": "3cf6",
	"./hero/mobile_map_caruaru.svg": "cb23",
	"./hero/mobile_map_catanzaro.svg": "d387",
	"./hero/mobile_map_chile_hospicio.svg": "c690",
	"./hero/mobile_map_chile_urban.svg": "b173",
	"./hero/mobile_map_chileebuscovid19.svg": "dbca",
	"./hero/mobile_map_cityanalyticsmobility.svg": "6417",
	"./hero/mobile_map_colina.svg": "d72d",
	"./hero/mobile_map_collepardo.svg": "b9fe",
	"./hero/mobile_map_concepcion.svg": "37d2",
	"./hero/mobile_map_concepcionhospital.svg": "d574",
	"./hero/mobile_map_conchali.svg": "748e",
	"./hero/mobile_map_curitiba.svg": "c3db",
	"./hero/mobile_map_ezeiza.svg": "aced",
	"./hero/mobile_map_firenze.svg": "1361",
	"./hero/mobile_map_gemonadelfriuli.svg": "c4a9",
	"./hero/mobile_map_genova.svg": "69b2",
	"./hero/mobile_map_granada.svg": "3a30",
	"./hero/mobile_map_jaboatao.svg": "1d33",
	"./hero/mobile_map_jean.svg": "acfb",
	"./hero/mobile_map_laflorida.svg": "7eda",
	"./hero/mobile_map_lanus.svg": "d986",
	"./hero/mobile_map_lecce.svg": "d00f",
	"./hero/mobile_map_lima.svg": "0a2e",
	"./hero/mobile_map_madrid.svg": "9346",
	"./hero/mobile_map_masloc.svg": "fc80",
	"./hero/mobile_map_mataro.svg": "ad66",
	"./hero/mobile_map_mateu.svg": "941a",
	"./hero/mobile_map_merida.svg": "9694",
	"./hero/mobile_map_messina.svg": "a15d",
	"./hero/mobile_map_milan.svg": "5997",
	"./hero/mobile_map_monza.svg": "324b",
	"./hero/mobile_map_openindex.svg": "1566",
	"./hero/mobile_map_penalonen.svg": "b84b",
	"./hero/mobile_map_pescara.svg": "5985",
	"./hero/mobile_map_quincy.svg": "903f",
	"./hero/mobile_map_recea.svg": "df31",
	"./hero/mobile_map_reggiocalabria.svg": "3ebd",
	"./hero/mobile_map_regional.svg": "e13a",
	"./hero/mobile_map_rome.svg": "c1be",
	"./hero/mobile_map_sanmauro.svg": "b1a3",
	"./hero/mobile_map_santarosa.svg": "d78d",
	"./hero/mobile_map_sarria.svg": "ec1c",
	"./hero/mobile_map_sernobi.svg": "e024",
	"./hero/mobile_map_sevilla.svg": "c76c",
	"./hero/mobile_map_siracusa.svg": "cbdc",
	"./hero/mobile_map_trieste.svg": "6b6d",
	"./hero/mobile_map_turin.svg": "ea7b",
	"./hero/mobile_map_tussam.svg": "f9ad",
	"./hero/mobile_map_vernazza.svg": "3126",
	"./hero/mobile_map_vitoria.svg": "7c54",
	"./hero/mobile_map_zaragoza.svg": "0cae",
	"./hero/moncalieri2.png": "ba95",
	"./hero/moncalieri_1.png": "68ba",
	"./hero/moncalieri_arch_hero_card.png": "b79f",
	"./hero/moncalieri_hero_card.png": "008d",
	"./hero/monza_background_hero.png": "55ee",
	"./hero/openindex_hero_bg.png": "2ccb",
	"./hero/openindex_hero_card.png": "88b3",
	"./hero/penalonen_background_hero.png": "2fc3",
	"./hero/penalonen_hero_card.png": "c6d7",
	"./hero/pescara_background_hero.png": "9a0c",
	"./hero/quincy_background_hero.png": "3fc1",
	"./hero/recea_background_hero.png": "f48a",
	"./hero/reggiocalabria_hero.png": "a945",
	"./hero/reggiocalabria_hero_card.png": "0301",
	"./hero/regional_background_hero.png": "66cf",
	"./hero/reislighting_background_hero.png": "1a23",
	"./hero/romaBus.png": "4ce3",
	"./hero/romaebus_hero_bg.png": "1dfa",
	"./hero/rome_background_hero.png": "28c3",
	"./hero/sanmauro_background_hero.png": "712a",
	"./hero/sanpaolo_background_hero.png": "10a9",
	"./hero/santarosa_background_hero.png": "7bbb",
	"./hero/santarosa_hero_card.png": "e2a4",
	"./hero/santiago_background.png": "375f",
	"./hero/santiago_background_hero.png": "1ec8",
	"./hero/santiagodechileebus_background_hero.png": "bb8e",
	"./hero/sarria_background_hero.png": "6014",
	"./hero/sernobi_background_hero.png": "95fb",
	"./hero/sevilla_background_hero.png": "de16",
	"./hero/sevilla_hero_card.png": "6286",
	"./hero/siracusa.png": "4b1a",
	"./hero/siracusa_hero_card.png": "454d",
	"./hero/stresa_hero_bg.png": "0af0",
	"./hero/stresa_hero_card.png": "7dd9",
	"./hero/tango_background_hero.png": "2647",
	"./hero/trieste_background_hero.png": "3be5",
	"./hero/trieste_hero_card.png": "eee0",
	"./hero/turin_background_hero.png": "01ad",
	"./hero/tussam_hero_bg.png": "393e",
	"./hero/tussam_hero_card.png": "341e",
	"./hero/vernazza_background_hero.png": "3d86",
	"./hero/vernazzaheritage_background_hero.png": "c38d",
	"./hero/villa_giulia_hero_bg.png": "8e3d",
	"./hero/villa_giulia_hero_card.png": "df5f",
	"./hero/vitoria_background_hero.png": "c066",
	"./hero/zaragoza_background.png": "e789",
	"./hero/zaragoza_background_hero.png": "3c49",
	"./hero/zaragoza_background_hero_2.png": "da7f",
	"./hero/zaragoza_hero_card.png": "43a5",
	"./illuminaromania.png": "f1a7",
	"./illuminazionehoc.png": "962b",
	"./impegnocongiunto.png": "4594",
	"./impianti.png": "47f0",
	"./infrastrutture.png": "c09f",
	"./investimento.png": "cf1d",
	"./jaboataoprogetto.png": "fc84",
	"./juicelamp.png": "4de3",
	"./juicemedia.png": "ee95",
	"./laboratoriomobile.png": "1114",
	"./ledargentina.png": "da65",
	"./legnanocitta.png": "ac83",
	"./legnanopiazza.png": "a1d3",
	"./lucenatalelima.png": "06e5",
	"./luceradente.png": "7891",
	"./lucesostenibile.png": "ba13",
	"./lucipalazzi.png": "b4f1",
	"./lucispettacolo.png": "4a1f",
	"./mateusanitaria.png": "5af7",
	"./mateusolari.png": "e4ed",
	"./meridaprogetto.png": "2fe1",
	"./meridasmart.png": "9368",
	"./messina_energia.png": "5362",
	"./messina_progetto.png": "c04a",
	"./metanocile.png": "e2c1",
	"./milanonataleduomo.png": "48bf",
	"./milanopannelli.png": "85f6",
	"./milanovistaalto.png": "848d",
	"./ministero_difesa.png": "bd58",
	"./ministero_difesa_zoom.png": "550f",
	"./modellourbano.png": "047c",
	"./modernizzare.png": "b72a",
	"./modernizzazione.png": "5813",
	"./modernizzazioneimpianto.png": "bc9b",
	"./modernizzazioneveloce.png": "666f",
	"./modernromania.png": "b522",
	"./moncaliericitta.png": "1012",
	"./moncalieripermanente.png": "d758",
	"./moncalieripiazza.png": "52e4",
	"./moncalieriponte.png": "f660",
	"./monitoraggio.png": "701f",
	"./natale2022.png": "45cc",
	"./nataleangra.png": "06e3",
	"./notturnagotica.png": "bc7d",
	"./numeribestcase.png": "25c3",
	"./numerisifda.png": "10be",
	"./ognimomento.png": "7a24",
	"./openindex_screenshot_1.png": "1a36",
	"./openindex_screenshot_2.png": "02f8",
	"./pacificanto.png": "42db",
	"./palazziled.png": "de94",
	"./palazzimonza.png": "11ab",
	"./pantografo.png": "a4fb",
	"./partenariato.png": "0bac",
	"./partner.png": "52f5",
	"./partnerlocali.png": "5fa5",
	"./partnership.png": "be20",
	"./passatofuturo.png": "8f9b",
	"./penalonenvista.png": "c243",
	"./personalizzazione.png": "9321",
	"./piano360.png": "d13b",
	"./piscinarecord.png": "6bff",
	"./politiche.png": "032d",
	"./pontesanmauro.png": "0fc1",
	"./portataditutti.png": "2480",
	"./potenziareitinerari.png": "56fe",
	"./presidiosalute.png": "e26e",
	"./progettoargentina.png": "d5e1",
	"./progettoenelx.png": "e156",
	"./progettohospicio.png": "ca4a",
	"./progettomataro.png": "b205",
	"./progettoromania.png": "175e",
	"./propostacongiunta.png": "d3e1",
	"./raccontarsi.png": "6d97",
	"./reggioinnovativo.png": "d505",
	"./reggiosostenibile.png": "37c7",
	"./reisnumeri.png": "5b40",
	"./relamping.png": "c596",
	"./remotecontrol.png": "e3011",
	"./rivoluzionegreen.png": "0352",
	"./romaautobus.png": "9008",
	"./romabuses.png": "c133",
	"./sanpaolocycle.png": "3a4d",
	"./sanpaoloinnovazione.png": "c967",
	"./santarosaebus1.png": "fc1e",
	"./santarosaebus2.png": "cf8e",
	"./sculture.png": "347f",
	"./sevillainvestimento.png": "8fc5",
	"./sevillapannellisolari.png": "4a22",
	"./sevillaprogetto.png": "837f",
	"./sicurezzaelettrica.png": "3fe5",
	"./sicurezzahospicio.png": "136d",
	"./sicurezzasanmauro.png": "f6fa",
	"./siracusacosta.png": "e410",
	"./siracusapiazza.png": "5f74",
	"./soluzionecompleta.png": "d856",
	"./soluzionejean.png": "a4d5",
	"./soluzionemodernizzazione.png": "4b26",
	"./sostenibilita.png": "3ee1",
	"./spazionuovo.png": "df58",
	"./starlima.png": "7bd9",
	"./stresa.png": "1ee1",
	"./strumentopa.png": "307d",
	"./studioquincy.png": "8d36",
	"./tangorisoluzione.png": "04a1",
	"./tangoservizio.png": "c340",
	"./tecnologialed.png": "1b8d",
	"./tecnologiamataro.png": "807c",
	"./telecontrollo.png": "2ddb",
	"./terprogetto.png": "c8ce",
	"./tertelecontrollo.png": "42c7",
	"./tesori.png": "252e",
	"./tipologiaanalisi.png": "5b79",
	"./transizioneebus.png": "e921",
	"./transmilenio.png": "d914",
	"./triestepiazza.png": "a0c8",
	"./tussam_contratto.png": "8c7a",
	"./tussam_progetto.png": "e1ce",
	"./valorizzazione.png": "8405",
	"./vernazzasmart.png": "8d75",
	"./videoPlaceholders/analtyticsmonza.png": "03e4",
	"./videoPlaceholders/architectural.png": "0dcf",
	"./videoPlaceholders/assisi.png": "4cf6",
	"./videoPlaceholders/autobus.png": "157a",
	"./videoPlaceholders/bogotaendue.png": "51b3",
	"./videoPlaceholders/bogotaesdue.png": "6269",
	"./videoPlaceholders/bogotaestre.png": "2315",
	"./videoPlaceholders/buenosled.png": "9c52",
	"./videoPlaceholders/car.png": "c738",
	"./videoPlaceholders/carsbologna.png": "e137",
	"./videoPlaceholders/christmast.png": "e2ba",
	"./videoPlaceholders/cityanalytics.png": "094b",
	"./videoPlaceholders/cityanalyticscovid19.png": "9365",
	"./videoPlaceholders/cityangra.png": "687b",
	"./videoPlaceholders/citycycle.png": "934f",
	"./videoPlaceholders/coloured.png": "bfbe",
	"./videoPlaceholders/elettrificazionetrasporti.png": "b005",
	"./videoPlaceholders/energyefficiency.png": "303d",
	"./videoPlaceholders/futurosarria.png": "6b1d",
	"./videoPlaceholders/goticaburgos.png": "df57",
	"./videoPlaceholders/illuminazionearchitetturale.png": "a133",
	"./videoPlaceholders/illuminazionepubblica.png": "80fa",
	"./videoPlaceholders/juicelamp.png": "2eab",
	"./videoPlaceholders/limalighting.png": "a313",
	"./videoPlaceholders/mateupa.png": "f3a6",
	"./videoPlaceholders/multifunctional.png": "58a4",
	"./videoPlaceholders/openindex.png": "7c32",
	"./videoPlaceholders/operaio.png": "9ffd",
	"./videoPlaceholders/pasolutions.png": "378a",
	"./videoPlaceholders/quincy.png": "011b",
	"./videoPlaceholders/recharge.png": "2758",
	"./videoPlaceholders/riconoscimentofacciale.png": "eb14",
	"./videoPlaceholders/sanmauropa.png": "9ead",
	"./videoPlaceholders/sicurezzaflorida.png": "300f",
	"./videoPlaceholders/smartcity.png": "4907",
	"./videoPlaceholders/solar_energy.png": "7496",
	"./videoPlaceholders/soluzionismartbuildings.png": "89b2",
	"./videoPlaceholders/spettacololuci.png": "40ff",
	"./videoPlaceholders/stadium.png": "0f00",
	"./videoPlaceholders/temporalperu.png": "ab7a",
	"./videoPlaceholders/trasportipubblici.png": "a7df",
	"./videoPlaceholders/trasportipubblicichile.png": "bc2b",
	"./videoPlaceholders/trellis_sunset.jpeg": "d41e",
	"./videoPlaceholders/turinjuicemedia.png": "bb6d",
	"./videoPlaceholders/vernazzapatrimonio.png": "6c8a",
	"./villa_giulia.png": "0e52",
	"./villa_giulia_bellezza.png": "df98",
	"./visioneinsieme.png": "35cc",
	"./vivibilita.png": "65f2",
	"./zaragozaebus.png": "2e99",
	"./zeroemissionicile.png": "ce83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a60";